import React from "react";
import { Route } from "react-router-dom";
import { useAuth } from "../../context/auth-context";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../errorHandling/error-fallback-page";
import { handleBoundaryError } from '../../utils/globalErrorHandler';
import { useAuthCheck } from "../../context/auth-check-context";
import RouteLoadingSpinner from "../loading/RouteLoadingSpinner";
import LoginRedirect from "./LoginRedirect";

/**
 * ManagerRoute - Route wrapper that requires authentication and manager privileges.
 * Shows a loading spinner while the auth check is in progress.
 * Redirects to `/login` when the user is unauthenticated or lacks manager access.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.component - The component to render for authorized managers.
 * @returns {JSX.Element}
 */
export default function ManagerRoute({ component: Component, ...rest }) {
    const { currentUser } = useAuth();
    const { isManager, loading } = useAuthCheck();

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleBoundaryError}>
            <Route
                {...rest}
                render={(props) => {
                    if (loading) return <RouteLoadingSpinner />;
                    return currentUser && isManager ? (
                        <Component {...props} />
                    ) : (
                        <LoginRedirect />
                    );
                }}
            />
        </ErrorBoundary>
    );
}
